import { render } from "./ContactPersonAtom.vue?vue&type=template&id=7297d5a2&scoped=true"
import script from "./ContactPersonAtom.vue?vue&type=script&lang=js"
export * from "./ContactPersonAtom.vue?vue&type=script&lang=js"

import "./ContactPersonAtom.vue?vue&type=style&index=0&id=7297d5a2&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7297d5a2"]])

export default __exports__